export default __webpack_public_path__ + "static/media/overview.35cc1d25.gif";